import { ErrorHandler, Injectable, inject } from '@angular/core';
import { TelemetryService } from './services/telemetry.service';

@Injectable()
export class TelemetryErrorHandler implements ErrorHandler {
  private readonly telemetryService = inject(TelemetryService);

  handleError(error: unknown): void {
    const exception = error instanceof Error ? error : new Error(String(error));
    this.telemetryService.trackException(exception, { source: 'GlobalErrorHandler' });
    // Re-throw so the browser still logs it to the console
    console.error(error);
  }
}